const Renderer = require('../Renderer');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
/**
 * 像素聚合渲染
 * @ignore
 * @param {Object} options - 构造参数；
 * @param {G.Map} options.map - 地图对象
 * @param {String} options.id
 * @param {String} options.name
 * @param {String} options.idField
 * @param {Object} options.featureBuilder
 * @param {String} options.geometryType
 * @param {Object} options.listenEvents
 */
let renderer = Renderer.extend({
    options: {},
    initialize(options) {
        Renderer.prototype.initialize.call(this, options);
        //
        this.gvInstance = null;
        this.featureCol = {
            type: 'FeatureCollection',
            features: []
        }
        this.initListeners();
    },

    /**
     */
    destroy() {
        this.featureCol.features = [];
        this.featureCol = null;
        this.destroyGvInstance();
        Renderer.prototype.destroy.call(this);
    },

    /**
     * @returns {*}
     */
    getLayer() {
        return this.getGvInstance();
    },

    /**
     *
     * @param list
     */
    add(list) {
        let start = new Date().getTime();
        let len = list.length;
        let geometryBuilder = this.options.featureBuilder.options.geometryBuilder;
        let idField = this.options.idField;
        let features = this.featureCol.features;
        for (let i = 0; i < len; i++) {
            let item = list[i];
            item.id = item.id || item[idField];
            let geometry = geometryBuilder.build(item);
            let feature = {
                id: item.id,
                geometry: geometry.asGeoJson(),
                properties: item
            }
            features.push(feature);
        }
        this.render();
        // console.debug('add ' + len + ' featrues , cost ' + (new Date().getTime() - start) + ' ms');
    },

    /**
     *
     * @param list
     */
    update(list) {
        let start = new Date().getTime();
        let len = list.length;
        let geometryBuilder = this.options.featureBuilder.options.geometryBuilder;
        let idField = this.options.idField;
        let appendFeautures = [];
        for (let i = 0; i < len; i++) {
            let item = list[i];
            item.id = item.id || item[idField];
            let geometry = geometryBuilder.build(item);
            let feature = {
                id: item.id,
                geometry: geometry.asGeoJson(),
                properties: item
            }
            let findResult = this._getFeatureById(feature.id);
            if (findResult.index >= 0) {
                this.featureCol.features[findResult.index] = feature;
            } else {
                appendFeautures.push(feature);
            }
        }
        this.featureCol.features = this.featureCol.features.concat(appendFeautures);
        this.render();
        // console.debug('update cost ' + (new Date().getTime() - start) + ' ms');
    },

    /***
     *
     * @param id
     */
    remove(id) {
        let findResult = this._getFeatureById(id);
        if (findResult.index >= 0) {
            this.featureCol.features.splice(findResult.index, 1);
            this.render();
            return findResult.feature;
        }
        return null;
    },
    //
    _getFeatureById(id) {
        let result = {
            feature: null,
            index: -1
        };
        for (let i = 0, len = this.featureCol.features.length; i < len; i++) {
            let feature = this.featureCol.features[i];
            if (id == feature.id) {
                result.feature = feature;
                result.index = i;
                break;
            }
        }
        return result;
    },

    //
    render() {
        let source = new gv.source.GeoJsonSource(this.featureCol);
        let gvInstance = this.getGvInstance();
        if (gvInstance.source.featureCollection.features.length == 0 &&
            source.featureCollection.features.length == 0) {
            return;
        }
        gvInstance.setDataSource(source);
        gvInstance.render();
    },

    /**
     */
    clear() {
        this.featureCol.features = [];
        this.render();
    },

    setVisible(visible) {
        let instance = this.getGvInstance();
        if (instance) {
            instance.setVisible(!!visible);
            return true;
        }
        return false;
    },

    getVisible() {
        let instance = this.getGvInstance();
        if (instance) {
            return instance.getVisible();
        }
        return undefined;
    },

    addListeners() {
        if (this.gvInstance) {
            this.gvInstance.on('click', this.onClick);
            this.gvInstance.on('mouseover', this.onMouseOver);
            this.gvInstance.on('mouseout', this.onMouseOut);
        }
    },

    removeListeners() {
        if (this.gvInstance) {
            this.gvInstance.un('click', this.onClick);
            this.gvInstance.un('mouseover', this.onMouseOver);
            this.gvInstance.un('mouseout', this.onMouseOut);
        }
    },

    //
    initListeners() {
        this.onClick = (event) => {
            this.fireEvent('click', event);
        }
        this.onMouseOver = (event) => {
            this.fireEvent('mouseover', event);
        }
        this.onMouseOut = (event) => {
            this.fireEvent('mouseout', event);
        }
    },

    //
    fireEvent(eventName, eventData) {
        if (eventData) {
            if (this.options.eventDispatcher.listens(eventName)) {
                let data = {};
                let temp = {};
                for (let k in eventData) {
                    if (k == 'geometry') {
                        continue;
                    }
                    temp[k] = eventData[k];
                }
                let element = new g2.sfs.Element({
                    id: temp[this.options.idField],
                    geometry: g2.sfs.GeometryFactory.createGeometryFromGeoJson(eventData.geometry)
                });
                element.attributeSet = this.options.featureBuilder.buildAttributeSet(temp);
                data.featureType = this.options.id;
                data.featureName = this.options.name;
                data.element = element;
                data.elementId = element.id;
                this.options.eventDispatcher.fire(eventName, data);
                //each listeners
                let listener = this.options.eventDispatcher.listener(this.options.id, eventName);
                if (listener) {
                    listener(eventData);
                }
            }
        }
    },

    /**
     */
    getGvInstance() {
        if (this.gvInstance == null) {
            let source = new gv.source.GeoJsonSource(this.featureCol);
            this.gvInstance = new gv.chart.PointClusterChart(source, this.getGvOptions());
            this.gvInstance.bind(this.options.map, gv.chart.MapType.TSMap);
            this.addListeners();
            this.gvInstance.renderComplete(() => {
                //render complete
                this.gvInstance.setVisible(this.gvInstance.getVisible());
            });
        }
        return this.gvInstance;
    },

    getGvOptions() {
        return this.options.featureBuilder.options.symbolBuilder.build();
    },

    /**
     * 销毁
     * 
     */
    destroyGvInstance() {
        if (this.gvInstance) {
            this.gvInstance.unbind(this.options.map);
            this.removeListeners();
            this.gvInstance = null;
        }
    },
});

module.exports = renderer;